import React, { useContext, useState } from 'react'
import './index.scss'
import selectIcon from '../../assets/images/ic_select.png'
import selectedIcon from '../../assets/images/ic_selected.png'
import showMore from '../../assets/images/ic_showmore.png'
import showLess from '../../assets/images/ic_showless.png'
import SecondCategory from '../SecondCategory'
import { CategoriesContext } from '../../lib/context'
export interface ICateGoryItem {
    category: {
        displayTerm: string
        id?: string
        parentId?: string
        term: string
    }
    children: ICateGoryItem[]
    rootCategoryId?: string
    rootSortedId?: number
}

interface IFirstCateGoryProps {
    firstCategory: ICateGoryItem
}
const FirstCateGory = (props: IFirstCateGoryProps) => {
    const { firstCategory } = props
    const { category, children } = firstCategory
    const categoriesContext: any = useContext(CategoriesContext)
    const [showChildren, setshowChildren] = useState(false)
    const selectCategory = () => {
        categoriesContext?.clickCategory(category.id)
    }
    let isSelect = categoriesContext?.selectCategory.indexOf(category.id) !== -1
    return (
        <>
            <div className="firstCate">
                <div className="leftCategory" onClick={selectCategory}>
                    <img
                        className="selectIcon"
                        src={isSelect ? selectedIcon : selectIcon}
                        alt=""
                    ></img>
                    <span
                        className={`categoryName ${isSelect ? 'active' : ''}`}
                    >
                        {category.displayTerm}
                    </span>
                </div>
                <div
                    className="rightCategory"
                    onClick={() => setshowChildren(!showChildren)}
                >
                    <img
                        className="rightIcon"
                        src={showChildren ? showLess : showMore}
                        alt=""
                    ></img>
                </div>
                {/*  */}
            </div>
            {children &&
                showChildren &&
                children.map((item, index) => {
                    return (
                        <SecondCategory
                            key={`second${index}`}
                            secondCategory={item}
                        ></SecondCategory>
                    )
                })}
        </>
    )
}

export default FirstCateGory
